import React from 'react';
import ScheduleCall from '../common/schedule-call';
import ClientCarousel from '../home/client-carousel';

const TechHeroSupplyChain = () => {
    return (
        <section className="hero home-hero technology-herosection relative aiml-hero-section">
            <video playsInline autoPlay muted loop className="aimlvideo" height="100%" width="100%">
                <source src="media/supply-chain-bg.mp4" type="video/mp4" />
            </video>
            <div className="counter-overlay"></div>
            <div className="container lg:container md:mx-auto top-hero">
                <div className="row grid lg:grid-cols-12 hero-row gap-6 relative z-[1] h-full">
                    <div className="lg:col-span-8 md:col-span-11 gap-4 grid">
                        <div className="inline-flex flex-col lg:items-start gap-5 hero-content justify-center h-full">
                            <p className="mb-0 fs-lg font-semibold text-white">Supply Chain Software Development Company</p>
                            <h1 className="mb-0 text-yellow">Supercharge Logistics, Inventory & Operations with Moweb</h1>
                            <p className="mb-0 font-semibold text-white">
                                At Moweb, we craft smart supply chain software that simplifies logistics, inventory, and
                                operations. With real-time tracking and AI-driven insights, we bring speed, accuracy, and control
                                to your processes.From warehouses to last-mile delivery, we help you scale without chaos. Trusted
                                by global leaders in retail, logistics, and healthcare.
                            </p>
                            <ScheduleCall />
                        </div>
                    </div>
                </div>
            </div>
            <ClientCarousel />
        </section>
    );
};

export default TechHeroSupplyChain;
